import axios from 'axios'

export type ApiErrorPayload = {
  code?: string
  message?: string
  details?: Array<{ field?: string; message?: string }>
  meta?: unknown
}

export type ExtractedApiError = {
  message: string
  code?: string
  details?: Array<{ field: string; message: string }>
  highlightFields: string[]
}

const DEFAULT_MESSAGE = 'Ocorreu um erro inesperado. Tente novamente.'

function normalizeDetails(
  details: ApiErrorPayload['details'],
): Array<{ field: string; message: string }> | undefined {
  if (!details?.length) return undefined
  return details
    .filter((d): d is { field: string; message: string } => Boolean(d?.field && d?.message))
    .map((d) => ({ field: d.field, message: d.message }))
}

/** Extrai mensagem/código/detalhes do envelope padrão da API (`success: false, error: {...}`). */
export function extractApiError(error: unknown, fallback = DEFAULT_MESSAGE): ExtractedApiError {
  if (!axios.isAxiosError(error)) {
    return { message: fallback, highlightFields: [] }
  }

  const payload = error.response?.data as
    | { error?: ApiErrorPayload; message?: string }
    | undefined

  const apiError = payload?.error
  const message =
    apiError?.message?.trim() ||
    (typeof payload?.message === 'string' ? payload.message.trim() : '') ||
    fallback

  const details = normalizeDetails(apiError?.details)
  const highlightFields = details?.map((d) => d.field) ?? []

  if (apiError?.code === 'REUNIAO_REQUIRED' && !highlightFields.includes('dataReuniao')) {
    highlightFields.push('dataReuniao')
  }
  if (apiError?.code === 'EMAIL_REQUIRED' && !highlightFields.includes('email')) {
    highlightFields.push('email')
  }
  if (apiError?.code === 'DORES_REQUIRED' && !highlightFields.includes('dores')) {
    highlightFields.push('dores')
  }
  if (
    (apiError?.code === 'DATA_REUNIAO_REQUIRED' || apiError?.code === 'DATA_REUNIAO_INVALID') &&
    !highlightFields.includes('dataReuniao')
  ) {
    highlightFields.push('dataReuniao')
  }

  return {
    message,
    code: apiError?.code,
    details,
    highlightFields,
  }
}
